module.exports = __webpack_public_path__ + "static/media/img78_R.f311fe67.jpg";